import client from '@/plugins/axios.js'

export default  {
    productList(){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).get('/api/product/products')
                .then((res)=>{
                    resolve(res.data.data)
                })
                .catch((err)=>{
                    reject(err)
                })
        });
    },
  
    productStock(){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).get('/api/product/stock')
                .then((res)=>{
                    resolve(res.data.data)
                })
                .catch((err)=>{
                    reject(err)
                })
        });
    },
  
    productsOfType(type){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).get('/api/product/productsOfType/'+type)
                .then((res)=>{
                    resolve(res.data.data)
                })
                .catch((err)=>{
                    reject(err)
                })
        });
    },
  
    categoryList(){
      return new Promise((resolve,reject)=>{
        //console.log("Service:product about to call api/product/categories");
        client({requiresAuth:true}).get('/api/product/categories')
          .then((res)=>{
            let cat = res.data.data
            resolve({'list':cat, 'dataTimestamp':res.data.dataTimestamp})
          })
          .catch((err)=>{
            reject(err)
          })
      });
    }

}
